export default {
  install: (Vue: any) => {
    // 4. adicionar um método de instância
    Vue.prototype.$styleRouteItem = (entity: any) => {
      if (entity.detached == 1) {
        if (entity.pendencies?.length) {
          return "warning"
        } else if (entity.finished) {
          return "secondary text-white"
        } else {
          return "secondary text-white"
        }
      } else if (entity.pendencies?.length && !entity.finished) {
        return "warning"
      } else {
        if (entity.pendencies?.length && entity.finished) {
          return "warning"
        } else if (
          entity.finished &&
          entity.status == 2 &&
          entity.type_abnormality == "I"
        ) {
          return "danger"
        } else if (
          entity.finished &&
          entity.status == 2 &&
          entity.type_abnormality == "P"
        ) {
          return "success text-white"
        } else if (entity.status == "1") {
          return "primary text-white"
        } else if (entity.status == "2") {
          return "success text-white"
        } else if (entity.status == "3") {
          return "danger"
        } else {
          return ""
        }
      }
    }
  },
}
